export const setPreviewCardState = (cardEl, { imgUrl = '', videoUrl = '', showImg = false, showVideo = false, placeholderText = '', loading = false } = {}) => {
  if (!cardEl) return;

  const icon = cardEl.querySelector('.character-preview-card__icon');
  const placeholder = cardEl.querySelector('.character-preview-card__placeholder');
  const img = cardEl.querySelector('img.character-preview-card__media');
  const video = cardEl.querySelector('video.character-preview-card__media');
  const loader = cardEl.querySelector('.three-dots-loader');

  const showVideoEl = !loading && showVideo && !!videoUrl;
  const showImgEl = !loading && showImg && !!imgUrl;
  const showEmpty = !loading && !showVideoEl && !showImgEl;

  if (placeholder && placeholderText) placeholder.textContent = placeholderText;

  if (img) {
    if (showImgEl) img.src = imgUrl;
    else img.removeAttribute('src');
    img.classList.toggle('hidden', !showImgEl);
  }
  if (video) {
    if (showVideoEl) video.src = videoUrl;
    else {
      video.removeAttribute('src');
      video.load?.();
    }
    video.classList.toggle('hidden', !showVideoEl);
  }
  icon?.classList.toggle('hidden', !showEmpty);
  placeholder?.classList.toggle('hidden', !showEmpty);
  loader?.classList.toggle('hidden', !loading);
};
